import {
  Chip,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { ComplainLog } from "../models/complain.model";
import moment from "moment";
import { useEffect, useState } from "react";
import { complainReasonMap, titleStr } from "../lib/helper";
import { grey, red } from "@mui/material/colors";
import _ from "lodash";
import { COMPLAIN_STATUS_COLOR_MAP } from "./SurveyComplains";
import { getComplainLogs } from "../actions/complain.action";

function formatUserName(username: string) {
  const split = username.split(/[_-]/);
  return split.length >= 2 ? split[1] : split[0];
}

export default function SurveyComplainLogs(props: {
  eventId: string;
  submitId: string;
}) {
  const [logs, setLogs] = useState<ComplainLog[]>([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getComplainLogs({
      eventId: props.eventId,
      submitId: props.submitId,
    })
      .then(setLogs)
      .finally(() => setLoading(false));
  }, [props.eventId, props.submitId]);

  return (
    <div>
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
          }}
        >
          <CircularProgress />
        </div>
      )}
      {!loading && (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Username</TableCell>
              <TableCell sx={{ minWidth: 150 }}>Time</TableCell>
              <TableCell sx={{ minWidth: 80 }}>Status</TableCell>
              <TableCell>Note</TableCell>
              <TableCell sx={{ minWidth: 80 }}>Escalate</TableCell>
              <TableCell>Reason</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs
              .sort((a, b) => moment(b.createdAt).diff(moment(a.createdAt)))
              .map((log) => (
                <TableRow key={log.createdAt}>
                  <TableCell>{formatUserName(log.username)}</TableCell>
                  <TableCell>
                    {moment(log.createdAt).format("YYYY-MM-DD HH:mm:ss")}
                  </TableCell>
                  <TableCell>
                    {log.statusTo && (
                      <Chip
                        label={titleStr(log.statusTo)}
                        sx={{
                          backgroundColor:
                            COMPLAIN_STATUS_COLOR_MAP[log.statusTo],
                          color: "#fff",
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell>{log.details}</TableCell>
                  <TableCell>
                    {log.escalate && (
                      <Chip
                        label={titleStr(log.escalate)}
                        sx={{
                          backgroundColor:
                            log.escalate === "yes" ? red[500] : grey[500],
                          color: "#fff",
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {log.reason &&
                      complainReasonMap[
                        log.reason as keyof typeof complainReasonMap
                      ]}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
}
